import Reveal from "./Reveal";
import { IMAGES } from "@/constants/site";

export default function Intro() {
  return (
    <section className="w-full bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Text */}
          <Reveal className="lg:col-span-5">
            <span className="text-secondary-600 text-xs tracking-[0.3em] uppercase">
              Düzbağ Life
            </span>
            <h2 className="mt-5 font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-[1.15] font-medium">
              ŞEHRİN GÜRÜLTÜSÜNDEN
              <br />
              UZAKTA
            </h2>
            <div className="mt-6 h-px w-16 bg-accent-500" />
            <p className="mt-6 text-foreground-700 text-base md:text-lg leading-relaxed">
              Bazen ihtiyacınız olan şey yalnızca biraz yavaşlamak. Düzbağ Life,
              Çağlayancerit'in doğal dokusu içerisinde; ahşabın sıcaklığını,
              dağların dinginliğini ve suyun huzurunu bir araya getiriyor.
            </p>
            <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
              Fotoğraflarda gördüğünüz gerçek Düzbağ Life deneyimi; özgün A-frame
              bungalov mimarisi, sıcak ahşap iç mekânlar ve doğaya açılan
              pencerelerle sizi bekliyor.
            </p>
          </Reveal>

          {/* Collage */}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 gap-3 md:gap-5">
              <Reveal delay={80} className="col-span-1">
                <div className="w-full h-[260px] md:h-[420px] rounded-lg overflow-hidden">
                  <img
                    src={IMAGES.exterior}
                    alt="Düzbağ Life dış cephesi ve meyve bahçesi"
                    title="doğa içinde bungalov Kahramanmaraş"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </Reveal>
              <div className="flex flex-col gap-3 md:gap-5">
                <Reveal delay={140}>
                  <div className="w-full h-[150px] md:h-[200px] rounded-lg overflow-hidden">
                    <img
                      src={IMAGES.living}
                      alt="Düzbağ Life bungalov yaşam alanı ve ahşap merdiven"
                      title="Düzbağ Life ahşap iç mekan"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </Reveal>
                <Reveal delay={200}>
                  <div className="w-full h-[150px] md:h-[200px] rounded-lg overflow-hidden">
                    <img
                      src={IMAGES.bedroom}
                      alt="Düzbağ Life bungalov yatak odası"
                      title="Düzbağ Life bungalov konaklama"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </Reveal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}